import _classCallCheck from "D:/workspace/js/hotfix/sunway-web-ui/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "D:/workspace/js/hotfix/sunway-web-ui/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "D:/workspace/js/hotfix/sunway-web-ui/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "D:/workspace/js/hotfix/sunway-web-ui/node_modules/@babel/runtime/helpers/esm/createSuper";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/web.dom-collections.for-each.js";

/* eslint-disable no-undef */
// noinspection JSUnusedGlobalSymbols
import Base from './base.js';
import Gikam from '../core/gikam-core.js';
import jQuery from 'jquery';
import { I18N } from '@/gikam/i18n/I18N';
var defaultOptions = {
  url: void 0,
  taskId: void 0,
  data: void 0,
  columns: void 0,
  appendFields: [],
  requestParam: void 0,
  initData: void 0,
  success: [],
  fail: [],
  def: void 0,
  selectNextUser: false,
  selectNextRole: false,
  // 是否显示默认审核意见
  showDefaultOpinion: true,
  // 是否回车直接提交
  enterKeyConfirm: false,
  // 工作流历史审核意见是否展示为时间轴方式
  commentDisplayMode: 'grid'
};

var Workflow = /*#__PURE__*/function (_Base) {
  _inherits(Workflow, _Base);

  var _super = _createSuper(Workflow);

  function Workflow(props) {
    var _this2;

    _classCallCheck(this, Workflow);

    _this2 = _super.call(this);

    _this2.initialize(props, defaultOptions);

    _this2.removeEventHandle = null;
    _this2.options.def = jQuery.Deferred();
    return _this2;
  }

  _createClass(Workflow, [{
    key: "setDefaultOptions",
    value: function setDefaultOptions(options) {
      Gikam.extend(true, defaultOptions, options.defaultOptions);
    }
  }, {
    key: "validateUser",
    value: function validateUser(userId, password) {
      var pwd = Gikam.getJsonWrapper({
        password: Gikam.encryptPassword(password)
      });
      return Gikam.postText(Gikam.printf(Gikam.IFM_CONTEXT + '/open/core/module/mdm/user-passwords/userId/{userId}/action/validate-password', {
        userId: userId
      }), pwd);
    }
  }, {
    key: "submit",
    value: function submit(param) {
      Gikam.extend(true, this.options, param, {
        title: Gikam.propI18N(param.title || 'GIKAM.WORKFLOW.BUTTON.SUBMIT'),
        opinionTitle: Gikam.propI18N(param.opinionTitle || 'GIKAM.WORKFLOW.SUBMIT.OPINION.TITLE'),
        defaultOpinion: Gikam.propI18N(param.defaultOpinion || 'GIKAM.WORKFLOW.SUBMIT.OPINION.DEFAULT'),
        nextAuditorTitle: this.getNextAuditorTitle(param),
        fileUpload: false,
        url: param.pageObject.baseUrl + '/action/start-process',
        columns: param.pageObject.workflow.columns,
        //是否显示选择下级审核人或角色
        assignCandidate: true
      });
      this.options.bpmn_pass = 1;
      this.openOpinionModal();
      return this.options.def;
    }
  }, {
    key: "pass",
    value: function pass(param) {
      Gikam.extend(true, this.options, param, {
        title: Gikam.propI18N(param.title || 'GIKAM.WORKFLOW.BUTTON.PASS'),
        opinionTitle: Gikam.propI18N(param.opinionTitle || 'GIKAM.WORKFLOW.PASS.OPINION.TITLE'),
        defaultOpinion: Gikam.propI18N(param.defaultOpinion || 'GIKAM.WORKFLOW.PASS.OPINION.DEFAULT'),
        nextAuditorTitle: this.getNextAuditorTitle(param),
        fileUpload: true,
        url: param.pageObject.baseUrl + '/action/complete-task',
        columns: param.pageObject.workflow.columns,
        //是否显示选择下级审核人或角色
        assignCandidate: true
      });
      this.options.bpmn_pass = 1;
      this.openOpinionModal('pass');
      return this.options.def;
    }
  }, {
    key: "review",
    value: function review(param) {
      var _this = this;

      Gikam.create('modal', {
        title: 'GIKAM.WORKFLOW.REVIEW.MODAL.CHOOSE_USER',
        url: IFM_CONTEXT + '/secure/core/module/mdm/users/page/choose-list?targetType=audit',
        onAfterClose: function onAfterClose(rows) {
          if (rows) {
            var chooseData = {
              auditor: rows.map(function (item) {
                return item.id;
              })
            };
            Gikam.extend(true, _this.options, param, {
              title: Gikam.propI18N(param.title || 'GIKAM.WORKFLOW.BUTTON.REVIEW'),
              opinionTitle: Gikam.propI18N(param.opinionTitle || 'GIKAM.WORKFLOW.REVIEW.OPINION.TITLE'),
              defaultOpinion: Gikam.propI18N(param.defaultOpinion || 'GIKAM.WORKFLOW.REVIEW.OPINION.DEFAULT'),
              nextAuditorTitle: _this.getNextAuditorTitle(param),
              fileUpload: true,
              requestParam: chooseData,
              url: param.pageObject.baseUrl + '/action/review-task',
              columns: param.pageObject.workflow.columns
            });

            _this.openOpinionModal();
          }
        }
      });
      return _this.options.def;
    }
  }, {
    key: "delegate",
    value: function delegate(param) {
      var _this = this;

      Gikam.create('modal', {
        title: 'GIKAM.WORKFLOW.DELEGATE.MODAL.CHOOSE_USER',
        url: IFM_CONTEXT + '/secure/core/module/mdm/users/page/choose-list?targetType=audit',
        onAfterClose: function onAfterClose(rows) {
          if (rows) {
            var chooseData = {
              auditor: rows.map(function (item) {
                return item.id;
              })
            };
            Gikam.extend(true, _this.options, param, {
              title: Gikam.propI18N(param.title || 'GIKAM.WORKFLOW.BUTTON.DELEGATE'),
              opinionTitle: Gikam.propI18N(param.opinionTitle || 'GIKAM.WORKFLOW.DELEGATE.OPINION.TITLE'),
              defaultOpinion: Gikam.propI18N(param.defaultOpinion || 'GIKAM.WORKFLOW.DELEGATE.OPINION.DEFAULT'),
              nextAuditorTitle: _this.getNextAuditorTitle(param),
              fileUpload: true,
              requestParam: chooseData,
              url: param.pageObject.baseUrl + '/action/delegate-task',
              columns: param.pageObject.workflow.columns
            });

            _this.openOpinionModal();
          }
        }
      });
      return _this.options.def;
    }
  }, {
    key: "undo",
    value: function undo(param) {
      Gikam.extend(true, this.options, param, {
        title: Gikam.propI18N(param.title || 'GIKAM.BPMN.COMMENT.UNDO'),
        opinionTitle: Gikam.propI18N(param.opinionTitle || 'GIKAM.WORKFLOW.UNDO.OPINION.TITLE'),
        defaultOpinion: Gikam.propI18N(param.defaultOpinion || 'GIKAM.WORKFLOW.UNDO.OPINION.DEFAULT'),
        nextAuditorTitle: this.getNextAuditorTitle(param),
        fileUpload: false,
        url: param.pageObject.baseUrl + '/action/undo',
        columns: param.pageObject.workflow.columns
      });
      this.openOpinionModal();
      return this.options.def;
    }
  }, {
    key: "withdraw",
    value: function withdraw(param) {
      Gikam.extend(true, this.options, param, {
        title: Gikam.propI18N(param.title || 'GIKAM.BPMN.COMMENT.WITHDRAW'),
        opinionTitle: Gikam.propI18N(param.opinionTitle || 'GIKAM.WORKFLOW.WITHDRAW.OPINION.TITLE'),
        defaultOpinion: Gikam.propI18N(param.defaultOpinion || 'GIKAM.WORKFLOW.WITHDRAW.OPINION.DEFAULT'),
        nextAuditorTitle: this.getNextAuditorTitle(param),
        fileUpload: false,
        url: param.pageObject.baseUrl + '/action/withdraw-process'
      });
      this.options.bpmn_pass = -1;
      this.openOpinionModal();
      return this.options.def;
    }
  }, {
    key: "countersign",
    value: function countersign(param) {
      var _this = this;

      Gikam.create('modal', {
        title: 'GIKAM.WORKFLOW.COUNTERSIGN.MODAL.CHOOSE_USER',
        url: IFM_CONTEXT + '/secure/core/module/mdm/users/page/choose-list?targetType=audit',
        onAfterClose: function onAfterClose(rows) {
          if (rows) {
            var chooseData = {
              auditor: rows.map(function (item) {
                return item.id;
              })
            };
            Gikam.extend(true, _this.options, param, {
              title: Gikam.propI18N(param.title || 'GIKAM.WORKFLOW.BUTTON.COUNTERSIGN'),
              opinionTitle: Gikam.propI18N(param.opinionTitle || 'GIKAM.WORKFLOW.COUNTERSIGN.OPINION.TITLE'),
              defaultOpinion: Gikam.propI18N(param.defaultOpinion || 'GIKAM.WORKFLOW.COUNTERSIGN.OPINION.DEFAULT'),
              nextAuditorTitle: _this.getNextAuditorTitle(param),
              fileUpload: true,
              requestParam: chooseData,
              url: param.pageObject.baseUrl + '/action/countersign-task',
              columns: param.pageObject.workflow.columns
            });

            _this.openOpinionModal();
          }
        }
      });
      return _this.options.def;
    }
  }, {
    key: "reject",
    value: function reject(param) {
      if (Gikam.isEmpty(param.data)) {
        Gikam.alert('GIKAM.TIP.CHOOSE_AT_LEAST_ONE_ITEM');
        return this.options.def;
      }

      var _this = this;

      var bpmn_currentStatusCode = Gikam.getRequestParam(workspace.activeUrl).bpmn_currentStatusCode;
      var p = {
        bpmn_table: param.pageObject.workflow.dbTable
      };

      if (bpmn_currentStatusCode) {
        param.bpmn_currentStatusCode = bpmn_currentStatusCode;
      }

      var json = Gikam.getJsonWrapper(p, ['', param.data.map(function (item) {
        return {
          id: item.id
        };
      })]);
      workspace.window.showMask();
      Gikam.post(IFM_CONTEXT + '/secure/core/module/sys/bpmn-exts/options/rejectable-tasks', json).done(function (nodes) {
        var _nodes$;

        _this.options.requestParam = Gikam.extend(_this.options.requestParam, {
          reverse: true
        });
        Gikam.extend(true, _this.options, param, {
          title: Gikam.propI18N(param.title || 'GIKAM.WORKFLOW.BUTTON.REJECT'),
          opinionTitle: Gikam.propI18N(param.opinionTitle || 'GIKAM.WORKFLOW.REJECT.OPINION.TITLE'),
          defaultOpinion: Gikam.propI18N(param.defaultOpinion || 'GIKAM.WORKFLOW.REJECT.OPINION.DEFAULT'),
          nextAuditorTitle: _this.getNextAuditorTitle(param),
          fileUpload: false,
          url: param.pageObject.baseUrl + '/action/reject-task',
          columns: param.pageObject.workflow.columns,
          appendFields: [{
            title: Gikam.propI18N('GIKAM.WORKFLOW.REJECT.REJECT_TO_TITLE'),
            type: 'select',
            readonly: param['rejectToReadonly'] || false,
            field: 'bpmn_targetStatusCode',
            firstBlank: false,
            validators: ['notEmpty'],
            value: (_nodes$ = nodes[0]) === null || _nodes$ === void 0 ? void 0 : _nodes$.statusCode,
            items: nodes.map(function (item) {
              return {
                value: item.statusCode,
                text: item.taskName
              };
            })
          }]
        });
        _this.options.bpmn_pass = 0;

        _this.openOpinionModal();
      }).fail(function () {
        workspace.window.closeMask();
      });
      return this.options.def;
    }
  }, {
    key: "getBpmnTaskStatus",
    value: function getBpmnTaskStatus() {
      var _this3 = this;

      if (this.options.requestStatus === false) {
        var def = jQuery.Deferred();
        return def.resolve();
      }

      var params = this.options.data.map(function (item) {
        return {
          id: item.id
        };
      });
      var bpmnParams = this.options.bpmn_pass === null ? '' : {
        bpmn_pass: this.options.bpmn_pass
      };
      var url = this.options.pageObject.baseUrl + '/bpmn-task-status';
      var jsonWrapper = Gikam.getJsonWrapper(bpmnParams, ['', params]); //是不是需要校验用户名和密码、是否需要选择下级审核人或审核角色、是否需要上传附件

      return Gikam.post(url, jsonWrapper).done(function (r) {
        Gikam.extend(_this3.options, {
          bpmnTaskStatus: r
        });
      }).fail(function () {
        workspace.window.closeMask();
      });
    } // eslint-disable-next-line complexity

  }, {
    key: "getModalHeight",
    value: function getModalHeight() {
      var _this$options = this.options,
          appendFields = _this$options.appendFields,
          bpmnTaskStatus = _this$options.bpmnTaskStatus,
          assignCandidate = _this$options.assignCandidate;
      var defaultHeight = 230;

      if (assignCandidate && bpmnTaskStatus && bpmnTaskStatus.nextCandidatorOptStrategy && bpmnTaskStatus.nextCandidatorOptStrategy !== 'none') {
        defaultHeight += 42;
      }

      if (bpmnTaskStatus && bpmnTaskStatus.authRequired) {
        defaultHeight += 84;
      }

      if (bpmnTaskStatus && bpmnTaskStatus.attachmentStrategy && bpmnTaskStatus.attachmentStrategy !== 'none') {
        defaultHeight += 42;
      }

      if (Gikam.isNotEmpty(appendFields)) {
        var highHeightTypes = ['textarea', 'image', 'checkbox'];
        var highTypeFields = appendFields.filter(function (item) {
          return highHeightTypes.indexOf(item.type) > -1;
        });
        return appendFields.length * 42 + highTypeFields.length * 8 + defaultHeight;
      }

      return defaultHeight;
    }
  }, {
    key: "openOpinionModal",
    value: function openOpinionModal(type) {
      var _this4 = this;

      var _this = this;

      if (Gikam.isEmpty(this.options.data)) {
        Gikam.alert('GIKAM.TIP.CHOOSE_AT_LEAST_ONE_ITEM');
        return;
      }

      if (Gikam.isFalse(_this.options.manual)) {
        var opinion = {};
        opinion.bpmn_comment = _this.options.default_comment ? _this.options.default_comment : '';
        _this.options.opinionObject = opinion;

        _this.submitData();
      } else {
        workspace.window.showMask();
        this.getBpmnTaskStatus().done(function () {
          workspace.window.closeMask();
          var modal = Gikam.create('modal', {
            title: _this4.options.title,
            width: 500,
            height: _this4.options.height || _this4.getModalHeight(),
            onAfterClose: function onAfterClose(data) {
              if (!data) {
                return;
              }

              _this.options.opinionObject = data;
              delete _this.options.opinionModal;

              _this.submitData();

              _this.removeEventHandle && _this.removeEventHandle();
            },
            onBeforeClose: function onBeforeClose() {
              _this.removeEventHandle && _this.removeEventHandle();
            }
          });
          Gikam.extend(_this4.options, {
            opinionModal: modal
          });

          if (_this4.options.data.length === 1 && _this4.options.fileUpload) {
            _this4.getTaskId().done(function () {
              _this.createOpinionPage(type);
            });
          } else {
            _this.createOpinionPage(type);
          }
        });
      }
    }
  }, {
    key: "createOpinionPage",
    value: function createOpinionPage(type) {
      var _this5 = this;

      var bpmnTaskStatus = this.options.bpmnTaskStatus || {};
      var assignCandidate = this.options.assignCandidate; // 是否显示转办按钮

      var showTransfer = type === 'pass' && bpmnTaskStatus.transfer; // eslint-disable-next-line complexity

      var getFields = function getFields() {
        var fields = _this.options.appendFields; //是否选择下一级审核人/角色

        if (assignCandidate === true && bpmnTaskStatus.nextCandidatorOptStrategy === 'assigned') {
          fields = fields.concat({
            field: 'bpmn_nextCandidator_name',
            title: _this5.options.nextAuditorTitle,
            type: 'customChoose',
            single: false,
            mode: 'user',
            data: bpmnTaskStatus.candidatorList,
            validators: showTransfer ? [] : ['notEmpty'],
            onAfterChoose: function onAfterChoose(rows) {
              if (Gikam.isNotEmpty(rows)) {
                var users = '';
                var names = '';
                rows.forEach(function (user) {
                  users += user.id + ',';
                  names += user.userName + ',';
                });
                this.setData({
                  bpmn_nextCandidator: users.substr(0, users.length - 1),
                  bpmn_nextCandidator_name: names.substr(0, names.length - 1)
                });
              }
            }
          });
        }

        if (assignCandidate === true && bpmnTaskStatus.nextCandidatorOptStrategy === 'assignedRole') {
          fields = fields.concat({
            field: 'bpmn_nextCandidateRole_name',
            title: 'GIKAM.WORKFLOW.PASS.NEXT_ROLE',
            type: 'customChoose',
            mode: 'role',
            single: false,
            data: bpmnTaskStatus.candidateRoleList,
            validators: showTransfer ? [] : ['notEmpty'],
            onAfterChoose: function onAfterChoose(rows) {
              if (Gikam.isNotEmpty(rows)) {
                var roles = '';
                var names = '';
                rows.forEach(function (user) {
                  roles += user.id + ',';
                  names += user.roleName + ',';
                });
                this.setData({
                  bpmn_nextCandidateRole: roles.substr(0, roles.length - 1),
                  bpmn_nextCandidateRole_name: names.substr(0, names.length - 1)
                });
              }
            }
          });
        } else if (assignCandidate === true && bpmnTaskStatus.nextCandidatorOptStrategy === 'allUser') {
          fields = fields.concat({
            field: 'bpmn_nextCandidator_name',
            title: _this5.options.nextAuditorTitle,
            type: 'choose',
            single: false,
            category: 'user',
            validators: showTransfer ? [] : ['notEmpty'],
            onAfterChoose: function onAfterChoose(rows) {
              if (Gikam.isNotEmpty(rows)) {
                var users = '';
                var names = '';
                rows.forEach(function (user) {
                  users += user.id + ',';
                  names += user.userName + ',';
                });
                this.setData({
                  bpmn_nextCandidator: users.substr(0, users.length - 1),
                  bpmn_nextCandidator_name: names.substr(0, names.length - 1)
                });
              }
            }
          });
        } else if (assignCandidate === true && bpmnTaskStatus.nextCandidatorOptStrategy === 'allRole') {
          fields = fields.concat({
            field: 'bpmn_nextCandidateRole_name',
            title: 'GIKAM.WORKFLOW.PASS.NEXT_ROLE',
            type: 'choose',
            single: false,
            category: 'role',
            validators: showTransfer ? [] : ['notEmpty'],
            onAfterChoose: function onAfterChoose(rows) {
              if (Gikam.isNotEmpty(rows)) {
                var roles = '';
                var names = '';
                rows.forEach(function (user) {
                  roles += user.id + ',';
                  names += user.roleName + ',';
                });
                this.setData({
                  bpmn_nextCandidateRole: roles.substr(0, roles.length - 1),
                  bpmn_nextCandidateRole_name: names.substr(0, names.length - 1)
                });
              }
            }
          });
        }

        var validators = bpmnTaskStatus.commentRequired ? ['notEmpty'] : [];
        fields = fields.concat([{
          title: _this5.options.opinionTitle,
          field: 'bpmn_comment',
          type: 'textarea',
          height: 100,
          value: _this5.options.showDefaultOpinion === false ? '' : _this5.options.defaultOpinion,
          rows: 5,
          validators: validators
        }]);

        if (bpmnTaskStatus.authRequired) {
          fields = fields.concat([{
            title: '用户名',
            field: 'userId',
            type: 'text',
            readonly: true,
            validators: ['notEmpty'],
            value: workspace.user.id
          }, {
            title: '密码',
            field: 'password',
            type: 'password',
            validators: ['notEmpty']
          }]);
        }

        if (bpmnTaskStatus.attachmentStrategy && bpmnTaskStatus.attachmentStrategy !== 'none') {
          var _validators = null;

          if (bpmnTaskStatus.attachmentStrategy === 'mandatory') {
            _validators = ['notEmpty'];
          }

          fields = fields.concat({
            title: 'GIKAM.FILE.ATTACHMENT',
            field: 'bpmn_attachment',
            type: 'uploadButton',
            dbTable: 'BPMN',
            bizId: 'COMMENT',
            deleteUrl: Gikam.IFM_CONTEXT + '/core/module/item/files',
            validators: _validators,
            value: ''
          });
        }

        return fields;
      };

      var _this = this;

      var buttons = [{
        type: 'button',
        text: 'GIKAM.BUTTON.CONFIRM',
        class: 'blue',
        onClick: function onClick() {
          if (Gikam.getComp(formId).validate()) {
            var data = Gikam.getComp(formId).getData();

            if (bpmnTaskStatus.authRequired) {
              _this.validateUser(data.userId, data.password).done(function (r) {
                if (r === '1') {
                  _this.options.opinionModal.close(data);
                } else {
                  Gikam.alert('GIKAM.SECURITY.LOGIN.INCORRECT_USER_OR_PASSWORD');
                }
              });

              return;
            }

            _this.options.opinionModal.close(data);
          }
        }
      }, {
        type: 'button',
        text: 'GIKAM.BUTTON.CANCEL',
        onClick: function onClick() {
          _this.options.opinionModal.close();
        }
      }];

      if (showTransfer) {
        buttons.unshift({
          type: 'button',
          text: I18N.prop('workflow.transfer'),
          class: 'blue',
          onClick: function onClick() {
            if (Gikam.getComp(formId).validate()) {
              var data = Gikam.getComp(formId).getData();
              var config = Gikam.choose.getConfig('user');

              var selectTransferor = function selectTransferor() {
                Gikam.create('modal', {
                  title: I18N.prop('workflow.transferor'),
                  width: 618,
                  url: Gikam.IFM_CONTEXT + config.url + '?single=1',
                  onAfterClose: function onAfterClose(rows) {
                    if (!rows || !rows.length) {
                      Gikam.toast(I18N.prop('workflow.transferor.select'));
                      return;
                    }

                    data.bpmn_transferCandidator = rows[0].id;

                    _this.options.opinionModal.close(data);

                    _this.options.url = _this.options.pageObject.baseUrl + '/action/transfer-task';
                  }
                });
              };

              if (bpmnTaskStatus.authRequired) {
                _this.validateUser(data.userId, data.password).done(function (r) {
                  if (r === '1') {
                    selectTransferor();
                  } else {
                    Gikam.alert('GIKAM.SECURITY.LOGIN.INCORRECT_USER_OR_PASSWORD');
                  }
                });

                return;
              }

              selectTransferor();
            }
          }
        });
      }

      var formId = 'workflow-opinion-form-' + Date.now(),
          layout = Gikam.create('layout', {
        renderTo: this.options.opinionModal.window.$dom,
        center: {
          items: [{
            type: 'btnToolbar',
            items: buttons
          }, {
            type: 'form',
            columns: 1,
            id: formId,
            style: {
              padding: '10px'
            },
            fields: getFields()
          }]
        }
      });

      if (this.options.enterKeyConfirm) {
        var submitHandle = function submitHandle(e) {
          if (e.keyCode === 13) {
            if (!Gikam.getLastModal()) {
              document.removeEventListener('keyup', submitHandle);
              return;
            }

            buttons[0].onClick();
          }
        };

        document.addEventListener('keyup', submitHandle);

        this.removeEventHandle = function () {
          document.removeEventListener('keyup', submitHandle);
        };
      }

      this.options.$fileContainer = this.createFileContainer(layout);

      if (this.options.taskId) {
        this.getFiles().done(function (files) {
          if (files) {
            _this.refreshFileList([JSON.parse(files)]);
          }
        });
      }
    }
  }, {
    key: "createFileContainer",
    value: function createFileContainer(layout) {
      var fileContainerTpl = '<div class="workflow-upload-result-container">' + '<div class="inner-container">' + '<div class="title">' + Gikam.propI18N('GIKAM.FILE.ATTACHMENT') + '：</div>' + '</div>' + '</div>';
      return jQuery(fileContainerTpl).appendTo(layout.options.center.$dom).hide();
    }
  }, {
    key: "refreshFileList",
    value: function refreshFileList(files) {
      if (Gikam.isEmpty(files)) {
        return;
      }

      var itemTpl = '<a href="javascript:;" onclick="Gikam.printFile({id}, true, null, false, true)">{name}</a>';
      var itemHtml = '';
      Gikam.each(files, function () {
        itemHtml += Gikam.printf(itemTpl, this);
      });
      this.options.$fileContainer.children('.inner-container').children('a').remove().end().append(itemHtml);
      this.options.$fileContainer.show();
    }
  }, {
    key: "getFiles",
    value: function getFiles() {
      return Gikam.getText(Gikam.printf(IFM_CONTEXT + '/core/module/item/files/filter-target/{targetId}', {
        targetId: 'ACT_COMMENT_[{loginUserId}]$' + this.options.taskId
      }));
    }
  }, {
    key: "getTaskId",
    value: function getTaskId() {
      return Gikam.getJson(this.options.pageObject.baseUrl + "/".concat(this.options.data[0].id, "/info/status"));
    }
  }, {
    key: "uploadFile",
    value: function uploadFile() {
      var _this = this;

      _this.getFiles().done(function (r) {
        if (r) {
          Gikam.alert('GIKAM.FILE.TIP.UPLOAD_ONE_ONLY');
          return;
        }

        Gikam.create('simpleUploader', {
          multiple: false,
          onBeforeUpload: function onBeforeUpload() {
            this.setOptions({
              dbTable: 'ACT_COMMENT_[{loginUserId}]',
              bizId: _this.options.taskId
            });
          },
          onAfterClose: function onAfterClose() {
            _this.getFiles().done(function (files) {
              files && _this.refreshFileList([JSON.parse(files)]);
            });
          }
        });
      });
    }
  }, {
    key: "submitData",
    value: function submitData() {
      workspace.window.showMask();

      var _this = this;

      var backData = {};
      backData.bpmn_comment = this.options.opinionObject.bpmn_comment;
      Gikam.put(this.options.url, Gikam.getJsonWrapper(Gikam.extend(true, {}, this.options.requestParam, this.options.opinionObject), ['', this.options.data.map(function (item) {
        if (Gikam.isNotEmpty(item.version)) {
          return {
            id: item.id,
            version: item.version
          };
        } else {
          return {
            id: item.id
          };
        }
      })]), this.options.header).done(function () {
        _this.options.def.resolve(backData);
      }).always(function () {
        workspace.window.closeMask();
      });
    }
  }, {
    key: "getNextAuditorTitle",
    value: function getNextAuditorTitle(param) {
      return Gikam.propI18N(param.nextAuditorTitle || 'GIKAM.WORKFLOW.PASS.NEXT_AUDITOR');
    }
  }], [{
    key: "getDefaultOptions",
    value: function getDefaultOptions() {
      return defaultOptions;
    }
  }]);

  return Workflow;
}(Base);

export { Workflow as default };